module.exports = __webpack_public_path__ + "img/why-check-img3.6d1f4d08.png";